import { Spin } from 'antd';

const renderUpdater = () => {
    return (
        <div
            style={{
                marginTop: '100px',
            }}
        >
            <Spin size="large" />
            <br></br>
            <br></br>
            <span
                style={{
                    fontSize: '1.5rem',
                }}
            >
                Please wait - periods are updating.
                <br />
                Depending on the size of the account structure, this can take up to 30 minutes.
                <br />
                Please hold on.
            </span>
        </div>
    );
};

export default renderUpdater;
